import moment from 'moment'

export const division = {
  id: '',
  name: '',
  updatedAt : moment().format('YYYY-MM-DD'),
}